import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import "../styles/login.css";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    if (!username || !password) {
      setMessage("Моля, въведете потребител и парола");
      return;
    }

    try {
      const res = await api.post("Login/login", { username, password });
      localStorage.setItem("token", res.data.token);
      navigate("/admin");
    } catch {
      setMessage("Грешно име или парола!");
    }
  };

  return (
    <div className="login-container">

      {message && <p className="login-message">{message}</p>}

      <input
        type="text"
        placeholder="Потребител"
        value={username}
        onChange={(e) => { setUsername(e.target.value); setMessage(""); }}
      />
      <input
        type="password"
        placeholder="Парола"
        value={password}
        onChange={(e) => { setPassword(e.target.value); setMessage(""); }}
      />

      <button onClick={login}>Вход</button>
    </div>
  );
};

export default Login;
